module.exports = __webpack_public_path__ + "static/media/green_check_mark.eda8c9a5.png";